import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import CustomLoading from '../../../util_components/custom_loading';
import { image_error_replace, combine_name, check_null_text } from '../../../../util_functions';
import ScrollContainer from '../../../util_components/scroll_container';
import HighlightSearch from '../../../util_components/highlight_search_text';
import * as actions from '../../../../redux/action_creators';
import './list.css';

class StudentsList extends PureComponent {
  state = {
    students: [],
    modified_students: [],
    search_text: '',
    active_tab: 'students',
    expanded_lead_uuids: {}
  };

  componentDidMount() {
    if (this.props.filtered_students.length === 0) {
      // this.props.get_all_students();
    }
  }

  handle_search_input = (e) => {
    this.props.set_students_variable('search_students_list', []);
    this.props.set_loading_variable('student_search_status', 'none');
    this.props.set_students_variable('search_value', e.target.value);
    // this.setState({ search_text: e.target.value })
  };

  handle_search_text = (e) => this.props.filter_students(e.target.name, e.target.value);

  render_level_dropdown = () => (
    <select name="yoga_level" onChange={this.handle_search_text} value={this.props.yoga_level}>
      <option value="ALL">ALL</option>
      <option value="NEWBIE">NEWBIE</option>
      <option value="INTERMEDIATE">INTERMEDIATE</option>
      <option value="ADVANCED">ADVANCED</option>
    </select>
  );

  render_credits_dropdown = () => (
    <select name="credits" onChange={this.handle_search_text} value={this.props.credits}>
      <option value="ALL">ALL</option>
      <option value="0">0</option>
      <option value="25">25</option>
      <option value="50">50</option>
      <option value="75">75</option>
      <option value="100">100</option>
      <option value="125">125</option>
      <option value=">125">More than 125</option>
    </select>
  );

  render_type_dropdown = () => (
    <select name="user_type" onChange={this.handle_search_text} value={this.props.user_type}>
      <option value="ALL">ALL</option>
      <option value="REAL_USER">REAL USERS</option>
      <option value="TEST_USER">TEST USER</option>
      <option value="TEACHER_EVALUATOR">TEACHER EVALUATOR</option>
    </select>
  );

  open_student_profile = (e, client_domain) => {
    const url = '/studentprofile';
    const uuid = e.currentTarget.dataset.id;
    if (uuid) {
      const search = `?id=${uuid}`;
      this.props.history.push({
        pathname: url,
        search,
        state: { client_domain }
      });
    }
  };

  on_search_click = () => {
    const { search_value } = this.props;
    if (search_value.trim().length < 3) {
      this.props.set_notification_variable(
        true,
        'error',
        'Please type atlease 3 letters to search'
      );
    } else {
      this.props.search_students({
        search_param: search_value
      });
    }
  };

  input_handle_key = (e) => {
    if (e.keyCode === 13 || e.which === 13) {
      e.preventDefault();
      this.on_search_click();
    }
  };

  get_student_rows = () =>
    (this.props.search_students_list || []).filter((row) => (row.type || 'student') === 'student');

  get_onboarding_rows = () =>
    (this.props.search_students_list || []).filter((row) => row.type === 'onboarding');

  switch_tab = (tab) => this.setState({ active_tab: tab });

  toggle_lead_tries = (key) =>
    this.setState((prev) => ({
      expanded_lead_uuids: { ...prev.expanded_lead_uuids, [key]: !prev.expanded_lead_uuids[key] }
    }));

  render_students = () => {
    const students = this.get_student_rows();
    return (
      <div className="cus-table">
        <div className="ct-row ct-h">
          <div className="ct-col ct-qf">
            <img src="" alt="i" onError={image_error_replace} />
          </div>
          <div className="ct-col">Student (slug)</div>
          <div className="ct-col">EMAIL VERIFIED</div>
          {/* <div className="ct-col">USER TYPE</div> */}
          <div className="ct-col">PHONE</div>
          <div className="ct-col">YOGA LEVEL</div>
          <div className="ct-col ct-hf">CREDITS</div>
        </div>
        {students.map((student, index) => {
          const profile_photo = student.profile_photo ? student.profile_photo : '';
          const tr_class = student.student_uuid
            ? 'ct-row ct-cur tr-cursor-row'
            : 'ct-row tr-no-uuid';
          const sq_name = combine_name(student.sq_fname, student.sq_mname, student.sq_lname);
          const name = combine_name(student.first_name, student.middle_name, student.last_name);
          const st_slug = student.slug ? student.slug : '';
          const client_domain = student.client_domain
            ? student.client_domain === 'lifestyle'
              ? ''
              : 'Lifetree Health'
            : '';
          return (
            <div
              className={tr_class}
              key={student.student_uuid ? student.student_uuid : index}
              onClick={(e) => this.open_student_profile(e, student.client_domain)}
              data-id={student.student_uuid}
            >
              <div className="ct-col ct-qf">
                <img src={profile_photo} alt="i" onError={image_error_replace} />
              </div>
              <div className="ct-col ct-bw">
                <div style={{ fontSize: '17px' }}>
                  <HighlightSearch
                    full_text={name || sq_name}
                    search_text={this.props.search_value}
                  />
                  {st_slug ? (
                    <span className="sl-span">
                      (<HighlightSearch full_text={st_slug} search_text={this.props.search_value} />
                      )
                    </span>
                  ) : null}
                </div>
                {sq_name.trim().length > 0 &&
                sq_name.trim() !== 'User' &&
                !!name &&
                sq_name !== name ? (
                  <div style={{ fontSize: '14px', opacity: '0.7' }}>
                    <HighlightSearch full_text={sq_name} search_text={this.props.search_value} />
                  </div>
                ) : null}
                <div className="list-email ct-sm-font">
                  <HighlightSearch
                    full_text={student.email ? student.email : student.sq_email}
                    search_text={this.props.search_value}
                  />
                </div>
                {client_domain === '' ? null : (
                  <div className="bg-mytPurple px-2.5 py-1 w-fit text-white text-xs font-bold leading-3 rounded-lg mx-auto flex justify-center items-center">
                    {client_domain}
                  </div>
                )}
              </div>
              <div className="ct-col ct-si">
                {student.email_verified === 1 ? (
                  <img src="https://images.myyogateacher.com/icons/ic-checkmark-48.png" alt="av" />
                ) : (
                  <img src="https://images.myyogateacher.com/icons/ic-delete-48.png" alt="nav" />
                )}
              </div>
              {/* <div className="ct-col ct-ho">
								{student.test_user === 1 ? 'TEST USER' : null}
								{student.test_user === 1 && student.teacher_evaluator === 1 ? <br /> : null}
								{student.teacher_evaluator === 1 ? 'TEACHER EVALUATOR' : null}
							</div> */}
              <div className="ct-col ct-ho">
                <HighlightSearch
                  full_text={check_null_text(student.phone_personal)}
                  search_text={this.props.search_value}
                />
              </div>
              <div className="ct-col ct-ho">{student.yoga_level}</div>
              <div className="ct-col ct-ho ct-hf">{student.credits}</div>
            </div>
          );
        })}
      </div>
    );
  };

  render_students_mobile = () => {
    const students = this.get_student_rows();
    return (
      <div className="common-mobile-list">
        {students.map((student, index) => {
          const profile_photo = student.profile_photo ? student.profile_photo : '';
          const sq_name = combine_name(student.sq_fname, student.sq_mname, student.sq_lname);
          const name = combine_name(student.first_name, student.middle_name, student.last_name);
          let column_class = 'common-mobile-column';
          column_class += student.student_uuid ? ' ' : ' common-mobile-column-dis';
          column_class +=
            index % 2 === 0 ? ' common-mobile-column-even' : ' common-mobile-column-odd';
          return (
            <div
              className={column_class}
              onClick={this.open_student_profile}
              data-id={student.student_uuid}
              key={student.student_uuid ? student.student_uuid : index}
            >
              <div className="common-mobile-details">
                <div className="common-mobile-single-detail common-mobile-key">
                  STUDENT
                  <br />
                  <span style={{ fontSize: '14px', opacity: '0.7' }}>(Name given on LP)</span>
                </div>
                <div className="common-mobile-single-detail">
                  <div style={{ fontSize: '17px' }}>{name || sq_name}</div>
                  {sq_name.trim().length > 0 &&
                  sq_name.trim() !== 'User' &&
                  !!name &&
                  sq_name !== name ? (
                    <div style={{ fontSize: '14px', opacity: '0.7' }}>({sq_name})</div>
                  ) : null}
                  <div className="list-email">
                    {student.email ? student.email : student.sq_email}
                  </div>
                  <img src={profile_photo} onError={image_error_replace} alt="x" />
                </div>
              </div>
              <div className="common-mobile-details">
                <div className="common-mobile-single-detail common-mobile-key">Email VERIFIED</div>
                <div className="common-mobile-single-detail small-image-td">
                  {student.email_verified === 1 ? (
                    <img
                      src="https://images.myyogateacher.com/icons/ic-checkmark-48.png"
                      alt="av"
                    />
                  ) : (
                    <img src="https://images.myyogateacher.com/icons/ic-delete-48.png" alt="nav" />
                  )}
                </div>
              </div>
              <div className="common-mobile-details">
                <div className="common-mobile-single-detail common-mobile-key">USER TYPE</div>
                <div className="common-mobile-single-detail common-low-text">
                  {student.test_user === 1 ? 'TEST USER' : null}
                  {student.test_user === 1 && student.teacher_evaluator === 1 ? <br /> : null}
                  {student.teacher_evaluator === 1 ? 'TEACHER EVALUATOR' : null}
                </div>
              </div>
              <div className="common-mobile-details">
                <div className="common-mobile-single-detail common-mobile-key">YOGA LEVEL</div>
                <div className="common-mobile-single-detail common-low-text">
                  {student.yoga_level}
                </div>
              </div>
              <div className="common-mobile-details">
                <div className="common-mobile-single-detail common-mobile-key">
                  CREDITS AVAILABLE
                </div>
                <div className="common-mobile-single-detail common-low-text">{student.credits}</div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  render_student_container = () =>
    this.props.application_width > 700 ? this.render_students() : this.render_students_mobile();

  render_lead_try = (entry) => {
    const dt = entry.message_send_date || entry.created_date;
    const date_str = dt ? new Date(dt).toLocaleString() : '—';
    const status = entry.message_delivery_status || '—';
    const sent_by = entry.message_sent_by ? ` · sent by ${entry.message_sent_by}` : '';
    const err_code = entry.twilio_error_code;
    const err_msg = entry.twilio_error_message;
    return (
      <li
        key={entry.id || entry.onboard_anonymous_student_uuid || date_str}
        className="ol-try-item"
      >
        <span className="ol-try-dot" />
        <div className="ol-try-body">
          <div className="ol-try-line1">
            <span className="ol-try-status">SMS: {status}</span>
            {sent_by}
          </div>
          <div className="ol-try-line2">{date_str}</div>
          {err_code || err_msg ? (
            <div className="ol-try-error">
              <span className="ol-try-error-code">Twilio {err_code || '—'}</span>
              {err_msg ? <span className="ol-try-error-msg"> · {err_msg}</span> : null}
            </div>
          ) : null}
        </div>
      </li>
    );
  };

  render_onboarding_lead = (lead) => {
    const key = lead.onboard_anonymous_student_uuid || lead.id || lead.phone_personal;
    const expanded = !!this.state.expanded_lead_uuids[key];
    const past = Array.isArray(lead.past_tries) ? lead.past_tries : [];
    const name = (lead.student_name || '').trim() || 'Anonymous lead';
    const sent = lead.message_send_date || lead.created_date;
    const sent_str = sent ? new Date(sent).toLocaleString() : '—';
    const utm = [lead.utm_source, lead.utm_medium, lead.utm_content].filter(Boolean).join(' / ');
    return (
      <div className="ol-card" key={key}>
        <div className="ol-card-head">
          <div className="ol-card-name">
            {name}
            <span className="ol-card-phone">
              <HighlightSearch
                full_text={lead.phone_personal || ''}
                search_text={this.props.search_value}
              />
            </span>
          </div>
          <div className="ol-card-tags">
            {lead.is_verified === 1 ? (
              <span className="ol-tag ol-tag-success">phone verified</span>
            ) : (
              <span className="ol-tag ol-tag-muted">unverified</span>
            )}
            {lead.funnel_type ? <span className="ol-tag">{lead.funnel_type}</span> : null}
            {lead.offer_type ? <span className="ol-tag">{lead.offer_type}</span> : null}
          </div>
        </div>
        <div className="ol-card-meta">
          {utm ? <div>UTM: {utm}</div> : null}
          {lead.funnel_url ? (
            <div className="ol-card-url" title={lead.funnel_url}>
              {lead.funnel_url}
            </div>
          ) : null}
          <div>
            Last SMS: {lead.message_delivery_status || '—'} · {sent_str}
            {lead.message_sent_by ? ` · by ${lead.message_sent_by}` : ''}
          </div>
          {lead.twilio_error_code || lead.twilio_error_message ? (
            <div className="ol-card-error">
              <span className="ol-card-error-code">
                Twilio error {lead.twilio_error_code || '—'}
              </span>
              {lead.twilio_error_message ? (
                <span className="ol-card-error-msg"> · {lead.twilio_error_message}</span>
              ) : null}
            </div>
          ) : null}
        </div>
        {past.length > 0 ? (
          <div className="ol-card-tries">
            <button
              type="button"
              className="ol-card-tries-toggle"
              onClick={() => this.toggle_lead_tries(key)}
            >
              {expanded ? '▾' : '▸'} {past.length} previous{' '}
              {past.length === 1 ? 'attempt' : 'attempts'}
            </button>
            {expanded ? <ul className="ol-tries-list">{past.map(this.render_lead_try)}</ul> : null}
          </div>
        ) : null}
      </div>
    );
  };

  render_onboarding_leads = () => {
    const leads = this.get_onboarding_rows();
    if (leads.length === 0) {
      return (
        <div className="sl-display-cont">
          No onboarding leads found. They appear when you search by phone.
        </div>
      );
    }
    return <div className="ol-list">{leads.map(this.render_onboarding_lead)}</div>;
  };

  render_active_tab_body = () => {
    const search_value = this.props.search_value.trim();
    let display_text = '';
    if (search_value.length === 0) {
      display_text = 'Enter name, email or phone number to search';
    } else if (search_value.length > 0 && search_value.length < 3) {
      display_text = 'Please type atleast 3 letters to search';
    } else if (search_value.length >= 3) {
      display_text = 'Press Enter to search';
    }
    if (search_value.length >= 3 && this.props.student_search_status === 'success') {
      return this.state.active_tab === 'onboarding'
        ? this.render_onboarding_leads()
        : this.render_student_container();
    }
    return <div className="sl-display-cont">{display_text}</div>;
  };

  render_tabs = () => {
    const { student_search_status } = this.props;
    const show_counts =
      this.props.search_value.trim().length >= 3 && student_search_status === 'success';
    const student_count = this.get_student_rows().length;
    const lead_count = this.get_onboarding_rows().length;
    const tab_btn = (tab, label, count) => (
      <button
        type="button"
        className={`sl-tab${this.state.active_tab === tab ? ' sl-tab-active' : ''}`}
        onClick={() => this.switch_tab(tab)}
      >
        {label}
        {show_counts ? <span className="sl-tab-count">{count}</span> : null}
      </button>
    );
    return (
      <div className="sl-tabs">
        {tab_btn('students', 'Students', student_count)}
        {tab_btn('onboarding', 'Onboarding leads', lead_count)}
      </div>
    );
  };

  render() {
    const search_value = this.props.search_value.trim();
    return (
      <div className="common-page-container">
        <Helmet>
          <meta charSet="utf-8" />
          <title>All Users</title>
        </Helmet>
        <ScrollContainer />
        {this.props.student_search_status === 'loading' ? <CustomLoading /> : null}
        <h3>All Users</h3>
        <div className="sl-top-content">
          <div className="sl-top-inp">
            <input
              className="sl-input"
              placeholder="Enter name, email or phone number to search"
              name="search_value"
              value={this.props.search_value}
              onChange={this.handle_search_input}
              onKeyDown={this.input_handle_key}
            />
            <button onClick={this.on_search_click}>Search</button>
          </div>
          <div className="sl-top-leg">
            {search_value.length >= 3 &&
            this.props.student_search_status === 'success' &&
            this.state.active_tab === 'students' ? (
              <>
                <div className="sl-legend" />
                <span>Users not signed up</span>
              </>
            ) : null}
          </div>
        </div>
        {this.render_tabs()}
        {this.render_active_tab_body()}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  get_all_students_status: state.loading.get_all_students_status,
  filtered_students: state.students.filtered_students,
  search_value: state.students.search_value,
  yoga_level: state.students.yoga_level,
  credits: state.students.credits,
  user_type: state.students.user_type,
  search_students_list: state.students.search_students_list,
  student_search_status: state.loading.student_search_status,
  application_width: state.home.application_width
});

const mapDispatchToProps = (dispatch) => ({
  get_all_students: () => {
    dispatch(actions.get_all_students());
  },
  set_students_variable: (key, payload) => {
    dispatch(actions.set_students_variable(key, payload));
  },
  filter_students: (key, payload) => {
    dispatch(actions.filter_students(key, payload));
  },
  set_notification_variable: (show, type, mes) => {
    dispatch(actions.set_notification_variable(show, type, mes));
  },
  search_students: (payload) => {
    dispatch(actions.search_students(payload));
  },
  set_loading_variable: (key, payload) => {
    dispatch(actions.set_loading_variable(key, payload));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(StudentsList);
